import { render, staticRenderFns } from "./PurchaseSwitch.vue?vue&type=template&id=a8f249b4&"
import script from "./PurchaseSwitch.vue?vue&type=script&lang=js&"
export * from "./PurchaseSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports